/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { BidLevelingsControllerRemoveMutationResponse, BidLevelingsControllerRemovePathParams, BidLevelingsControllerRemove401, BidLevelingsControllerRemove403, BidLevelingsControllerRemove404 } from "../../models/bidsController/BidLevelingsControllerRemove";

function getBidLevelingsControllerRemoveUrl(id: BidLevelingsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/bid-levelings/${id}` as const }  
  return res
}

/**
 * @summary Soft-delete a trade
 * {@link /api/v1/bid-levelings/:id}
 */
export async function bidLevelingsControllerRemove(id: BidLevelingsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<BidLevelingsControllerRemoveMutationResponse, ResponseErrorConfig<BidLevelingsControllerRemove401 | BidLevelingsControllerRemove403 | BidLevelingsControllerRemove404>, unknown>({ method : "DELETE", url : getBidLevelingsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}